// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup_dim:has(.cp-childnode) {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n.cp-popup_wrap {\n  width: 350px;\n  margin-bottom: 100px;\n}\n.simplert__content:has(.cp-childnode) {\n  width: 550px !important;\n}\n.cp-th-disabled {\n  color: #aaaaaa !important;\n  background-color: #f6f6f6 !important;\n}\n", ""]);
// Exports
module.exports = exports;
